export enum enteteTableauListeMatriculesTauxEnum {
	matricule = 'Matricule',
	referenceImmeuble = 'Immeuble',
	dateDebut = 'Date début',
	dateFin = 'Date fin',
	tauxRecupResidentiel = 'Taux récup. résidentiel'
}